import { RequestKind, boolean, string } from '@sb/library/base';
import { TransactionCategoryDisplayItem, TransactionCategoryInputItem, TransactionCategoryUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace TransactionCategoriesRoutes { 
    export const Add = ApiRoute.Define({
        URL: `transactioncategories`,
        Kind: RequestKind.Post,
        ResultType: string,
        BodyType: TransactionCategoryInputItem,
    });

    export const Delete = ApiRoute.Define({
        URL: (transactionCategoryID: string) => `transactioncategories/${transactionCategoryID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean,
    });

    export const Get = ApiRoute.Define({
        URL: (transactionCategoryID: string) => `transactioncategories/${transactionCategoryID}`,
        Kind: RequestKind.Get,
        ResultType: TransactionCategoryDisplayItem,
    });

    export const Update = ApiRoute.Define({
        URL: (transactionCategoryID: string) => `transactioncategories/${transactionCategoryID}`,
        Kind: RequestKind.Put,
        ResultType: boolean,
        BodyType: TransactionCategoryUpdateItem
    });
}
